import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".calendar"
  });
}
